import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { subscribePaginatedAggregation } from '@adornis/baseql/server/resolver/mongo.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import { gateNexusSubscription } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { switchMap } from 'rxjs';
import { WorkflowState } from '../entities/WorkflowState.js';

export const subscribe = registerSubscription({
  operationName: 'WorkflowAPI_subscribe',
  resolve: (skip: number, limit: number, filter: AdornisFilter) => (gqlFields: BaseQLSelectionSet<WorkflowState>) =>
    gateNexusSubscription(NexusPermission.IntrospectionView, () =>
      watchQuery(WorkflowState._collectionName, {}).pipe(docs =>
        docs.pipe(
          switchMap(() =>
            subscribePaginatedAggregation(WorkflowState, skip, limit, filter.getMongoFilter(), [
              { $sort: { createdAt: -1 } },
            ]),
          ),
        ),
      ),
    ),
  type: () => [WorkflowState],
  params: [
    { name: 'skip', type: () => Int },
    { name: 'limit', type: () => Int },
    { name: 'filter', type: () => AdornisFilter },
  ],
});
